const loadState = () => {
    try {
      const serializedState = localStorage.getItem('zwerverhunt_settings');
      if (serializedState === null) {
        return undefined;
      }
      var state = JSON.parse(serializedState);

      console.log(state.maps);
      if(state.maps != undefined || state.maps == null) {
          state.maps = {
            center: { lat: 52.0263, lng: 5.5544 },
            zoom: 9
          }
      }

      if(state.baseCircle != undefined || state.baseCircle == null) {
          state.baseCircle = false;
      }

      return state;
    } catch (err) {
      return undefined;
    }
  };

  const saveState = (state) => {
    try {
      const serializedState = JSON.stringify(state);
      localStorage.setItem('zwerverhunt_settings', serializedState);
    } catch (err) {
      console.error(`Something went wrong: ${err}`);
    }
  }


const settings = {
    state: loadState() || {
        foxCircle: true,
        foxPath: true,
        fox: true,
        groups: true,
        cars: true,
        pois: false,
        zones: true,
        baseCircle: false,
        maps: {
            center: { lat: 52.0263, lng: 5.5544 },
            zoom: 9
        }
    },
    mutations: {
        ['SET_SETTING_FOX'] (state, status) {
            state.fox = status;
            saveState(state);
        },
        ['SET_SETTING_FOX_CIRCLE'] (state, status) {
            state.foxCircle = status;
            saveState(state);
        },
        ['SET_SETTING_FOX_PATH'] (state, status) {
            state.foxPath = status;
            saveState(state);
        },
        ['SET_SETTING_GROUPS'] (state, status) {
            state.groups = status;
            saveState(state);
        },
        ['SET_SETTING_CARS'] (state, status) {
            state.cars = status;
            saveState(state);
        },
        ['SET_SETTING_FOX_POIS'] (state, status) {
            state.pois = status;
            saveState(state);
        },
        ['SET_SETTING_FOX_ZONES'] (state, status) {
            state.zones = status;
            saveState(state);
        },
        ['SET_SETTING_MAP_CENTER'] (state, location) {
            state.maps.center = location;
            saveState(state);
        },
        ['SET_SETTING_MAP_ZOOM'] (state, zoom) {
            state.maps.zoom = zoom;
            saveState(state);
        },
        ['SET_SETTING_BASE_CIRCLE'] (state, val) {
            state.baseCircle = val;
            saveState(state);
        }
    },
    getters: {
        settings: state => {
            return state;
        }
    }
};

export default settings;


// WEBPACK FOOTER //
// ./src/store/modules/settings.js